// HubSpot トラッキングコード（public/index.html の hs-script-loader）を
// SPA のルート変更に追従させるユーティリティ。
//
// 埋め込みスクリプトは「初回ロード時のページ」しか自動計測しない。
// react-router で画面が切り替わっても新しいページビューは飛ばないため、
// ルート変更のたびに setPath → trackPageView を明示的に積む必要がある。

/** HubSpot のトラッキングキュー。スクリプト未ロードでも積んでおけば後で処理される。 */
function queue() {
  if (typeof window === "undefined") return null;
  window._hsq = window._hsq || [];
  return window._hsq;
}

/** ルート変更を HubSpot に通知する。 */
export function trackHubSpotPageView(path) {
  const _hsq = queue();
  if (!_hsq) return;
  _hsq.push(["setPath", path]);
  _hsq.push(["trackPageView"]);
}

/**
 * HubSpot の訪問者識別クッキー（hubspotutk）を返す。
 *
 * Forms Submission API に context.hutk として渡すと、その送信が
 * 「トラッキング済みの訪問セッション」に紐づき、流入元・閲覧履歴が
 * コンタクトに引き継がれる。渡さない場合 HubSpot は流入元を判定できず、
 * すべて OFFLINE / DIRECT_TRAFFIC として記録されてしまう。
 */
export function getHubSpotUtk() {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}
